import _ from 'lodash';
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
//import Select from '@material-ui/core/Select';
//import Input from '@material-ui/core/Input';
//import MenuItem from '@material-ui/core/MenuItem';
//import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';

import Grid from '@material-ui/core/Grid';
import { sortStationsByNumber } from '../../libs/utility';
import { gridMargin } from './general';

export default class StationTankSelect extends PureComponent {
	constructor(props) {
		super(props);
		this.state = {
			stationTanks: [],
		};
	}

	componentDidMount() {
		this.setupOptions();
	}

	componentDidUpdate() {
		this.setupOptions();
	}

	setupOptions = () => {
		const { stations, doNotShowInactive } = this.props;

		if (_.isEmpty(stations)) {
			return;
		}
		if (!_.isEmpty(this.state.stationTanks)) {
			return;
		}

		const stationTanks = [];
		stations.forEach((station) => {
			if (!station.tanks) {
				return;
			}
			const { stationId, number, name, stationIsNotActive } = station;

			_.sortBy(station.tanks, 'tankNumber').forEach((tank) => {
				const { productType } = tank;
				let tankNumber = tank.tankNumber ? tank.tankNumber : 1;
				const tankDisplay = ` / Tank #${tankNumber} - ${productType.toUpperCase()}`;

				if (doNotShowInactive) {
					if (stationIsNotActive === true) {
						return;
					}
				}

				stationTanks.push({
					stationId,
					tankNumber,
					productType,
					tankDisplay,
					number,
					name,
					id: `${stationId}~${tankNumber}~${productType}`,
				});
			});
		});
		this.setState({ stationTanks });
	};

	render() {
		const { label, value, path, onChange, error, helpText, md } = this.props;
		let { stationTanks } = this.state;

		if (_.isEmpty(stationTanks)) {
			return null;
		}

		const hasError = !!error;
		const _onChange = (_event, newValue) => {
			if (!newValue) {
				return {};
			}
			const { stationId, tankNumber, productType } = newValue;
			onChange({ stationId, tankNumber, productType }, path);
		};

		let id = '';
		if (_.isObject(value) && !_.isEmpty(value)) {
			id = `${value.stationId}~${value.tankNumber}~${value.productType}`;
		}

		const sortedOptions = sortStationsByNumber(stationTanks);
		const valueOption = _.find(sortedOptions, { id });

		return (
			<Grid container spacing={2}>
				<Grid item xs={12} md={md} style={gridMargin}>
					<FormControl fullWidth={true} error={!!error}>
						{/* <InputLabel>{label}</InputLabel> */}

						<Autocomplete
							autoHighlight={true}
							options={sortedOptions}
							value={valueOption}
							getOptionLabel={(option) => {
								const { number, name, tankDisplay } = option;
								return `${number} - ${name} ${tankDisplay}`;
							}}
							renderOption={(option) => {
								const { number, name, tankDisplay } = option;
								return (
									<span>
										{number} - {name} <span style={{ color: '#666' }}>{tankDisplay}</span>
									</span>
								);
							}}
							onChange={_onChange}
							renderInput={(params) => <TextField {...params} label={label} fullWidth />}
						/>
						{hasError && <FormHelperText>{error}</FormHelperText>}
						{helpText && !hasError && <FormHelperText>{helpText}</FormHelperText>}
					</FormControl>
				</Grid>
			</Grid>
		);
	}
}

StationTankSelect.propTypes = {
	label: PropTypes.string,
	value: PropTypes.object,
	path: PropTypes.string.isRequired,
	onChange: PropTypes.func.isRequired,
	error: PropTypes.string,
	stations: PropTypes.array.isRequired,
	md: PropTypes.number,
	helpText: PropTypes.string,
	doNotShowInactive: PropTypes.bool,
};

StationTankSelect.defaultProps = {
	md: 6,
};
